import React, { useState } from 'react';
import { Layout } from './components/Layout/index';
import { ToastContainer } from './components/UI/index';
import { useToast } from './hooks/index';
import { useAuthStore } from './stores/authStore';
import LoginPage from './pages/LoginPage';
import {
  Dashboard,
  QueuePage,
  PlayersPage,
  MatchPage,
  HistoryPage,
  StatisticsPage,
  SettingsPage
} from './pages/index';

function App() {
  const [currentPage, setCurrentPage] = useState<string>('dashboard');
  const { toasts, hideToast } = useToast();
  const { isAuthenticated, login, error, clearError } = useAuthStore();

  // Handle login
  const handleLogin = (username: string, password: string) => {
    clearError();
    login(username, password);
  };

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} error={error || undefined} />;
  }

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard onNavigate={setCurrentPage} />;
      case 'queue':
        return <QueuePage />;
      case 'players':
        return <PlayersPage />;
      case 'match':
        return <MatchPage />;
      case 'history':
        return <HistoryPage />;
      case 'statistics':
        return <StatisticsPage />;
      case 'settings':
        return <SettingsPage />;
      default:
        return <Dashboard onNavigate={setCurrentPage} />;
    }
  };

  return (
    <>
      <Layout currentPage={currentPage} onNavigate={setCurrentPage}>
        {renderPage()}
      </Layout>
      <ToastContainer toasts={toasts} onClose={hideToast} />
    </>
  );
}

export default App;
